import module from 'contabilidad/clientescuentascontables/module.js'
import template from './template.html'
import {orderBy} from 'lodash'

export class ContabilidadClientescuentascontablesDetalleCuentasComponent {
  data
  filtro = ''
  resultados = []
  eliminando = null

  constructor ($state, $dialog, $filter) {
    this.$state = $state
    this.$dialog = $dialog
    this.filterBy = $filter('filter')
  }

  $onInit () {
    this.data = orderBy(this.data, ['nombre', 'clasificacion', 'naturaleza'])
    this.filtrar()
  }

  editar (item) {
    this.$state.go('contabilidad.clientesCuentasContables.cliente.editar', {
      clasificacion: item.clasificacion,
      idProveedor: item.id_cliente_origen,
      idAdministrador: item.id_cliente_administrador,
      idCuenta: item.id_cuenta_bancaria,
      codigoConcepto: item.codigo_concepto,
    })
  }

  eliminar (items) {
    if (items) {
      items.forEach((item) => (this.data.splice(this.data.indexOf(item), 1)))
      this.filtrar()
    }

    this.eliminando = null
  }

  filtrar () {
    this.resultados = this.filterBy(this.data, this.filtro)
  }
}

module.component('contabilidadClientescuentascontablesDetalleCuentas', {
  controller: ContabilidadClientescuentascontablesDetalleCuentasComponent,
  template,
  bindings: {
    data: '<',
  },
})



// WEBPACK FOOTER //
// ./src/contabilidad/clientescuentascontables/components/detalle/cuentas/component.js